module.exports = __webpack_public_path__ + "static/img/zinifang.37cf896.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/zinifang.png
// module id = H5PZ
// module chunks = 1